<template>
	<div>
		<div class="google-map" ref="googleMap"></div>
		<template v-if="Boolean(this.google) && Boolean(this.map)">
			<slot
				:google="google"
				:map="map"
                :bounds="bounds"
                :project="project"
			/>
		</template>
	</div>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader'

export default {
    props: {
		mapConfig: Object,
		apiKey: String,
        heatMap: String,
        project: String
    },

    data() {
        return {
			google: null,
			map: null,
            bounds: null
        }
    },

    async mounted() {
        const googleMapApi = await GoogleMapsApiLoader({
          	apiKey: this.apiKey
        })

        this.google = googleMapApi
        this.initializeMap()
    },

    methods: {
        initializeMap() {
            const mapContainer = this.$refs.googleMap
            this.map = new this.google.maps.Map(
                mapContainer, this.mapConfig
            )

            this.bounds = new this.google.maps.LatLngBounds()

            if (this.heatMap !== '' ) {
                new google.maps.KmlLayer(this.heatMap, {
                    suppressInfoWindows: true,
                    preserveViewport: true,
                    map: this.map
                })
            }
        }
    },

    watch: {
        project () {
            this.initializeMap()
        }
    }
}

</script>

<style scoped>
	.google-map {
		height: 92vh;
		width: 100%;
	}
</style>